<template>
  <div>
    <h2>403 Forbidden</h2>
    <h2>У вас не хватает прав для доступа к этой странице.</h2>
  </div>
</template>

<script>
  export default {
    name: "Forbidden"
  }
</script>

<style scoped>

</style>